import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHeatExchangerFloatingHead = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 30,
	viewBox: "0 0 100.0 30.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 0,
			width: 100,
			height: 30,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 15.0 0.0 L 15.0 30.0 M 0.0 15.0 L 15.0 15.0 M 15.0 12.5 L 79.0 12.5 M 15.0 7.5 L 79.0 7.5 M 15.0 17.5 L 79.0 17.5 M 15.0 22.5 L 79.0 22.5",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 79,
			y: 5,
			width: 6,
			height: 20,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgHeatExchangerFloatingHead;
